import type {
  ProjectJob,
  ProjectJobKind,
  ProjectJobState,
} from '../api/types';

export function jobStateLabel(state: ProjectJobState): string {
  switch (state) {
    case 'queued':
      return 'در صف';
    case 'active':
      return 'در حال اجرا';
    case 'completed':
      return 'موفق';
    case 'failed':
      return 'ناموفق';
    case 'partial':
      return 'ناقص';
    case 'cancelled':
      return 'متوقف‌شده';
    default:
      return state;
  }
}

export function jobStateTone(
  state: ProjectJobState,
): 'success' | 'danger' | 'warning' | 'primary' | 'secondary' {
  if (state === 'completed') return 'success';
  if (state === 'failed') return 'danger';
  if (state === 'partial') return 'warning';
  if (state === 'cancelled') return 'secondary';
  if (state === 'active') return 'primary';
  return 'secondary';
}

export function jobTypeLabel(type: string | null | undefined): string | undefined {
  if (type === 'URL_UPDATED') return 'درخواست ایندکس';
  if (type === 'URL_DELETED') return 'حذف از نتایج';
  return type ?? undefined;
}

/** برچسب ستون «نوع» در تاریخچه — IndexNow معمولاً type خالی دارد. */
export function jobHistoryTypeLabel(job: ProjectJob): string | undefined {
  const fromType = jobTypeLabel(job.type);
  if (fromType) return fromType;
  if (job.kind === 'indexnow' || job.kind === 'google_index') {
    return 'درخواست ایندکس';
  }
  return undefined;
}

export function jobSearchEngineLabel(
  kind: ProjectJobKind,
): { icon: 'google' | 'globe2'; text: string } | undefined {
  if (kind === 'google_index') return { icon: 'google', text: 'گوگل' };
  if (kind === 'indexnow') return { icon: 'globe2', text: 'Bing / Yandex' };
  return undefined;
}

export function isJobDone(state: ProjectJobState): boolean {
  return (
    state === 'completed' ||
    state === 'failed' ||
    state === 'partial' ||
    state === 'cancelled'
  );
}

export function isJobRunning(state: ProjectJobState): boolean {
  return state === 'queued' || state === 'active';
}

export function canStopJob(job: ProjectJob): boolean {
  return (
    isJobRunning(job.state) &&
    (job.kind === 'inspect' || job.kind === 'google_index')
  );
}
